var PartnershipsSection = (function () {
  'use strict';

  var DESKTOP_BREAKPOINT = 768;
  var DESKTOP_VISIBLE    = 3;
  var MOBILE_VISIBLE     = 1.2;

  function init(sectionId) {
    var wrapper = document.getElementById('partnerships-carousel-' + sectionId);
    var track   = document.getElementById('partnerships-track-' + sectionId);

    if (!wrapper || !track) return;

    var slides      = Array.prototype.slice.call(track.querySelectorAll('.cp-partnerships__slide'));
    var totalSlides = slides.length;

    if (totalSlides === 0) return;

    var autoplayEnabled = wrapper.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed   = parseInt(wrapper.getAttribute('data-speed'), 10) || 3000;

    var currentIndex  = 0;
    var slideWidth    = 0;
    var gap           = 12;
    var autoplayTimer = null;

    // ─────────────────────────────────────────────
    // Slide sizing
    // ─────────────────────────────────────────────

    function getVisibleCount() {
      return window.innerWidth >= DESKTOP_BREAKPOINT ? DESKTOP_VISIBLE : MOBILE_VISIBLE;
    }

    function updateSlideSizes() {
      var visible    = getVisibleCount();
      var totalGap   = gap * (Math.floor(visible) - 1 + (visible % 1 > 0 ? 1 : 0));
      slideWidth     = (wrapper.offsetWidth - totalGap) / visible;

      slides.forEach(function (slide) {
        slide.style.width  = slideWidth + 'px';
        slide.style.height = Math.round(slideWidth * 0.65) + 'px';
      });
    }

    // ─────────────────────────────────────────────
    // Translation
    // ─────────────────────────────────────────────

    function getOffset(index) {
      return index * (slideWidth + gap);
    }

    function goTo(index, animate) {
      var maxIndex = totalSlides - Math.floor(getVisibleCount());
      currentIndex = Math.max(0, Math.min(index, maxIndex));

      if (animate === false) {
        track.style.transition = 'none';
      } else {
        track.style.transition = 'transform 0.4s ease';
      }

      track.style.transform = 'translateX(-' + getOffset(currentIndex) + 'px)';
    }

    function next() {
      var maxIndex = totalSlides - Math.floor(getVisibleCount());
      if (currentIndex >= maxIndex) {
        goTo(0);
      } else {
        goTo(currentIndex + 1);
      }
    }

    // ─────────────────────────────────────────────
    // Autoplay
    // ─────────────────────────────────────────────

    function startAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      autoplayTimer = setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    // Pause on hover
    wrapper.addEventListener('mouseenter', stopAutoplay);
    wrapper.addEventListener('mouseleave', startAutoplay);

    // ─────────────────────────────────────────────
    // Mouse drag
    // ─────────────────────────────────────────────

    var dragStartX   = 0;
    var dragCurrentX = 0;
    var isDragging   = false;
    var dragThreshold = 50;

    function onMouseDown(e) {
      isDragging   = true;
      dragStartX   = e.clientX;
      dragCurrentX = e.clientX;
      track.classList.add('is-dragging');
      stopAutoplay();
    }

    function onMouseMove(e) {
      if (!isDragging) return;
      dragCurrentX = e.clientX;
      var diff = dragStartX - dragCurrentX;
      track.style.transition = 'none';
      track.style.transform  = 'translateX(-' + (getOffset(currentIndex) + diff) + 'px)';
    }

    function onMouseUp() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');

      var diff = dragStartX - dragCurrentX;
      if (Math.abs(diff) > dragThreshold) {
        if (diff > 0) {
          goTo(currentIndex + 1);
        } else {
          goTo(currentIndex - 1);
        }
      } else {
        goTo(currentIndex);
      }

      startAutoplay();
    }

    track.addEventListener('mousedown', onMouseDown);
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);

    // ─────────────────────────────────────────────
    // Touch swipe
    // ─────────────────────────────────────────────

    var touchStartX   = 0;
    var touchCurrentX = 0;

    track.addEventListener('touchstart', function (e) {
      touchStartX   = e.touches[0].clientX;
      touchCurrentX = e.touches[0].clientX;
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      touchCurrentX = e.touches[0].clientX;
      var diff = touchStartX - touchCurrentX;
      track.style.transition = 'none';
      track.style.transform  = 'translateX(-' + (getOffset(currentIndex) + diff) + 'px)';
    }, { passive: true });

    track.addEventListener('touchend', function () {
      var diff = touchStartX - touchCurrentX;
      if (Math.abs(diff) > dragThreshold) {
        if (diff > 0) {
          goTo(currentIndex + 1);
        } else {
          goTo(currentIndex - 1);
        }
      } else {
        goTo(currentIndex);
      }
      startAutoplay();
    });

    // ─────────────────────────────────────────────
    // Resize
    // ─────────────────────────────────────────────

    var lastWidth   = window.innerWidth;
    var resizeTimer = null;

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (window.innerWidth !== lastWidth) {
          lastWidth = window.innerWidth;
          updateSlideSizes();
          goTo(currentIndex, false);
        }
      }, 200);
    });

    // ─────────────────────────────────────────────
    // Init
    // ─────────────────────────────────────────────

    updateSlideSizes();
    goTo(0, false);
    startAutoplay();
  }

  return {
    init: init
  };

})();
